import { render, staticRenderFns } from "./RequestsView.vue?vue&type=template&id=fcbf8f66"
import script from "./RequestsView.js?vue&type=script&lang=js&external"
export * from "./RequestsView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports